module.exports = "<p>\r\n  home works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/React/Antique/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = 1